var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconideationDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.0401L4 10.7541V3.00015C4.0001 2.53587 4.10795 2.07795 4.31507 1.66243C4.52218 1.24692 4.82292 0.88514 5.19359 0.605582C5.56427 0.326025 5.99477 0.136315 6.45121 0.0513851C6.90765 -0.0335447 7.37758 -0.0113765 7.824 0.116145L8.749 0.300145C9.38968 0.470904 9.95673 0.846971 10.3633 1.37075C10.7698 1.89452 10.9935 2.53713 11 3.20015V10.6701L12 10.9561L13 10.6701V3.20015C13.0032 2.54942 13.2169 1.91719 13.6091 1.39793C14.0013 0.87866 14.551 0.500221 15.176 0.319145L16.251 0.100145C16.6874 -0.0178824 17.1451 -0.0334425 17.5885 0.0546795C18.0319 0.142802 18.4489 0.33222 18.807 0.608145C19.1786 0.886211 19.48 1.24734 19.6872 1.66267C19.8943 2.078 20.0014 2.53602 20 3.00015V10.7531L12 13.0401ZM24 20.0001V6.00015C23.9974 5.38189 23.8039 4.77952 23.4459 4.27545C23.0879 3.77138 22.5829 3.39023 22 3.18415V12.2631L12 15.1201L2 12.2631V3.18415C1.41709 3.39023 0.912091 3.77138 0.554088 4.27545C0.196084 4.77952 0.00256297 5.38189 0 6.00015L0 20.0001H11V22.0001H7V24.0001H17V22.0001H13V20.0001H24Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconideationDark);
export default __webpack_public_path__ + "static/media/icon=ideation-dark.bc998d44d592b6b1f3057105aba7250b.svg";
export { ForwardRef as ReactComponent };